import { Component, Inject, Prop, Vue } from "vue-property-decorator";

import axios from "axios";

import template from "./document.vue";

import { IDocapost, IDocument } from "@/models/veos";
import SignatureService from "@/services/signatureService";

import store from "@/store";
const auth: string = "auth";

/**
 * Document
 */
@Component({
  mixins: [template],
})
export default class Document extends Vue {

  /** Services de signature électronique */
  @Inject() public signatureService!: () => SignatureService;
  /** Objet issu de l'appel à Docapost après signature */
  @Prop() protected docapost: IDocapost;
  /** Document à signer */
  @Prop() protected signatureDocument: IDocument;

  /** Propriétés de la pop-up de validation */
  protected confirmModal: any = {};
  /** Pop-up de validation */
  protected $dialog: any;

  /** Message d'erreur */
  protected errMsg: string = "";
  /**
   * Création de la vue
   */
  protected created() {
    this.confirmModal = {
      cancel: this.cancel,
      cancelText: this.$t("global.cancel"),
      loader: true,
      message: this.$t("components.document.confirm.message"),
      ok: this.confirm,
      okText: this.$t("global.valid"),
      reverse: true,
    };
  }

  /**
   * Récupère un document
   * @param idDoc identifiant du document
   * @returns un document
   */
  protected downloadDoc(idDoc: string) {
    axios({
      headers: {
        Authorization: "Bearer " +  + store.state[auth].token,
      },
      method: "get",
      responseType: "blob",
      url: store.state[auth].url + "rs/rsExtranet2/electronicSignature/document/" + idDoc,
    }).then((data) => {
      const blob = new Blob([data.data], { type: data.headers["content-type"] });
      const link = document.createElement("a");
      const linkUrl = URL.createObjectURL(blob);
      link.href = linkUrl;
      link.target = "_blank";
      link.click();
      URL.revokeObjectURL(link.href);
    },
    );
  }

  /**
   * Permets de basculer vers Docapost pour signer le document.
   * @param dialog pop-up de validation
   */
  protected goToSignDocument(dialog: any): void {
    if (this.signatureDocument.id) {
      this.signatureService().goToSignDocument(this.signatureDocument.id).then(
        (data: any) => {
          this.docapost = data.data;
          localStorage.setItem(process.env.VUE_APP_PARAM, this.docapost.documentId + "|" + this.signatureDocument.id);
          localStorage.setItem(process.env.VUE_APP_TOKEN, "" + store.state[auth].token);
          window.location.replace(this.docapost.url);
        },
        (data: any) => {
          if (data.data && "error" === data.data.key) {
            this.errMsg = "signresult." + data.data.value;
          }
          this.$emit("err", this.$t(this.errMsg));
          dialog.close();
        },
      );
    }
  }

  /**
   * Ouverture de la pop-up de validation
   * @param dialog pop-up de validation
   */
  protected confirm(dialog: any) {
    this.goToSignDocument(dialog);
  }

  /**
   * Action amenée via le bouton "Annuler" de la pop-up de validation
   */
  protected cancel() {
    // nothing
  }
}
